import CircularProgress from "@mui/material/CircularProgress/CircularProgress";
import "react-phone-number-input/style.css";
import Modal from "@mui/material/Modal";
import axios from "axios";
import { useEffect, useState, ChangeEvent } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "../../styles/logo.css";
import { Header } from "../header";
import Uploads from "../upload";
import address_detail from "../../asset/address_detail.json";
import { Container } from "@mui/material";
import { useImageStore, useLoginStore, usePektaStore } from "../helpers/state";
import PektaHeader from "../helpers/pektaHeader";
import Swal from "sweetalert2";

toast.configure();

export function PektaForm() {
  const { login } = useLoginStore();
  const {
    pektaData,
    updatePektaField,
    otherPektaData,
    updateOtherField,
    nextPage,
    page,
  } = usePektaStore();

  const { selectedImage } = useImageStore();

  const handleChange = (e: any) => {
    const { name, value } = e.target;
    updatePektaField(name, value.toUpperCase());

    // Clear employer fields if switching to SENDIRI or BERSARA
    if (
      name === "sektorPekerjaan" &&
      (value === "SENDIRI" || value === "BERSARA")
    ) {
      updateOtherField("namaMajikan", "");
      updateOtherField("alamatMajikan", "");
    }
  };

  const handleOtherChange = (e: any) => {
    const { name, value } = e.target;
    updateOtherField(name, value.toUpperCase());
  };

  function icnumber(ic: any) {
    var regex = /^(\d{2})(\d{2})(\d{2})(\d{2})(\d{3})(\d)$/;
    var matchResult = ic.match(regex);
    var year = matchResult[1];
    var month = matchResult[2];
    var day = matchResult[3];
    var gender = matchResult[6];

    // GET BIRTHDATE
    var now = new Date().getFullYear().toString();
    var decade = now.substr(0, 2);
    if (now.substr(2, 2) > year) {
      year = parseInt(decade.concat(year.toString()), 10);
    }

    var birthdate = new Date(year, month - 1, day, 0, 0, 0, 0);

    // GET GENDER
    var g = gender & 1 ? "LELAKI" : "PEREMPUAN";

    // GET AGE
    var age = new Date().getFullYear() - birthdate.getFullYear();

    updatePektaField("jantina", g);
    updatePektaField("umur", age);
  }

  function getTownOptions(selectedState: any) {
    const selectedStateData = address_detail.find(
      (stateData: any) => stateData.State === selectedState
    );
    if (selectedStateData) {
      if (selectedStateData.Towns.length < 2) {
        updatePektaField("bandar", selectedStateData.Towns[0].Name);
      }
      return selectedStateData.Towns.map((townData: any) => townData.Name);
    } else {
      return [];
    }
  }

  function getPostcodeOptions(selectedState: any, selectedTown: any) {
    const selectedStateData = address_detail.find(
      (stateData: any) => stateData.State === selectedState
    );
    if (selectedStateData) {
      if (selectedStateData.Towns.length < 2) {
        updatePektaField("bandar", selectedStateData.Towns[0].Name);
      }
      const selectedTownData = selectedStateData.Towns.find(
        (townData: any) => townData.Name === selectedTown
      );
      if (selectedTownData) {
        if (selectedTownData.Postcodes.length < 2) {
          updatePektaField("poskod", selectedTownData.Postcodes[0].toString());
        }
        return selectedTownData.Postcodes;
      } else {
        return [];
      }
    } else {
      return [];
    }
  }
  const [statedata, setStatedata] = useState<string[]>([]);
  const [citiesdata, setCitiesdata] = useState<string[]>([]);
  const [postcodedata, setPostcodedata] = useState<string[]>([]);
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  // const [upImage, setImage] = useState("");
  let formData2 = new FormData();
  const [mobileError, setMobileError] = useState<string | null>(null);
  const [officePhoneError, setOfficePhoneError] = useState<string | null>(null);
  const [homePhoneError, setHomePhoneError] = useState<string | null>(null);

  // Mobile: accept either local (e.g., 0123456789 or 01123456789) or +60 form (e.g., +60123456789)
  const mobileRegex =
    /^(?:01(?:1\d{8}|[02-46-9]\d{7})|\+601(?:1\d{8}|[02-46-9]\d{7}))$/;
  // Landline: accept either local 0XXXXXXXXX(9-10 digits) or +60XXXXXXXX(8-9 digits, without leading trunk 0)
  const landlineRegex = /^(?:0\d{8,9}|\+60(?!0)\d{8,9})$/;
  // const selfImage = (imageData: any) => {
  //   setImage(imageData);
  // };

  function upload() {
    setOpen(true);
    formData2.append("files", selectedImage);

    axios
      .post(`${process.env.REACT_APP_API_URL}/api/upload/`, formData2, {
        headers: {
          "content-type": `multipart/form-data`,
        },
      })
      .then((response) => {
        updatePektaField("gambar", response.data[0].id);
      })
      .then(() => {
        setOpen(false);
      })
      .then(() => {
        nextPage(2);
      })
      .catch((error) => {
        console.log("error: ", error);
        setOpen(false);
        const apiMsg =
          (error?.response?.data as any)?.error?.message ||
          (error?.response?.data as any)?.message ||
          error?.message ||
          "Dokumen tidak dihantar. Sila cuba semula.";
        Swal.fire({
          icon: "error",
          title: "Ralat Muat Naik",
          text: `${apiMsg}`,
        });
      });
  }

  function validateForm(e: any) {
    e.preventDefault();

    const trimObjectStrings = (obj: any): any => {
      if (typeof obj !== "object" || obj === null) {
        return obj;
      }

      for (const key in obj) {
        if (typeof obj[key] === "string") {
          obj[key] = obj[key].trim();
        } else if (typeof obj[key] === "object") {
          obj[key] = trimObjectStrings(obj[key]);
        }
      }

      return obj;
    };

    if (!pektaData) {
      return;
    }

    const trimmedFormData = trimObjectStrings(pektaData) as typeof pektaData;
    const trimmedOtherData = trimObjectStrings(
      otherPektaData
    ) as typeof otherPektaData;

    const normalizeToPlus60 = (raw: any): string => {
      if (raw === null || raw === undefined) return "";
      const s = String(raw).trim();
      if (s === "") return "";
      let digits = s.replace(/\D/g, "");
      if (digits.startsWith("60")) {
        digits = digits.slice(2);
      }
      if (digits.startsWith("0")) {
        digits = digits.slice(1);
      }
      if (digits.length === 0) return "";
      return "+60" + digits;
    };

    // Build specific missing fields list
    const missingFields: string[] = [];
    const labelMap: Record<string, string> = {
      firstName: "Nama Pengguna",
      kadPengenalan: "No Kad Pengenalan",
      umur: "Umur",
      jantina: "Jantina",
      sektorPekerjaan: "Sektor Pekerjaan",
      noTel: "No Tel Bimbit",
      tarafKahwin: "Status Perkahwinan",
      warganegara: "Warganegara Malaysia",
      bangsa: "Bangsa",
      alamat: "Alamat",
      negeri: "Negeri",
      bandar: "Daerah",
      poskod: "Poskod",
      akaunTH: "No Akaun TH",
      namaBank: "Nama Bank",
      akaunBank: "No Akaun Bank",
    };

    Object.keys(labelMap).forEach((key) => {
      const value = (trimmedFormData as Record<string, unknown>)[key];
      if (
        value === undefined ||
        value === null ||
        String(value).trim() === ""
      ) {
        missingFields.push(labelMap[key]);
      }
    });

    // Conditionally require 'pekerjaan' when sektor bukan BERSARA
    if (
      trimmedFormData.sektorPekerjaan &&
      trimmedFormData.sektorPekerjaan !== "BERSARA"
    ) {
      const pekerjaanValue = String(trimmedFormData.pekerjaan || "").trim();
      if (pekerjaanValue === "") {
        missingFields.push("Pekerjaan");
      }
    }

    // Kad pengenalan length check
    if (trimmedFormData.kadPengenalan?.length !== 12) {
      missingFields.push("No Kad Pengenalan perlu 12 digit");
    }

    // Selected image required
    if (selectedImage === null) {
      missingFields.push("Gambar Bersaiz Pasport");
    }

    // Employer details when required
    if (
      trimmedFormData.sektorPekerjaan !== "SENDIRI" &&
      trimmedFormData.sektorPekerjaan !== "BERSARA"
    ) {
      if (!trimmedOtherData.namaMajikan) missingFields.push("Nama Majikan");
      if (!trimmedOtherData.alamatMajikan) missingFields.push("Alamat Majikan");
    }

    // Phone format validations (no auto +60 or '-')
    const mobileValue = trimmedFormData.noTel || "";
    if (mobileValue && !mobileRegex.test(mobileValue)) {
      const usesPlus = mobileValue.startsWith("+");
      missingFields.push(
        usesPlus
          ? "Format No Tel Bimbit tidak sah (contoh: +60123456789 atau +601123456789)"
          : "Format No Tel Bimbit tidak sah (contoh: 0123456789 atau 01123456789)"
      );
    }

    const officeValue = trimmedOtherData.noPejabat || "";
    if (officeValue && !landlineRegex.test(officeValue)) {
      const usesPlus = officeValue.startsWith("+");
      missingFields.push(
        usesPlus
          ? "Format No Tel Pejabat tidak sah (contoh: +60387654321)"
          : "Format No Tel Pejabat tidak sah (contoh: 0387654321)"
      );
    }

    const homeValue = trimmedOtherData.noRumah || "";
    if (homeValue && !landlineRegex.test(homeValue)) {
      const usesPlus = homeValue.startsWith("+");
      missingFields.push(
        usesPlus
          ? "Format No Tel Rumah tidak sah (contoh: +6058765432)"
          : "Format No Tel Rumah tidak sah (contoh: 058765432)"
      );
    }

    if (missingFields.length > 0) {
      Swal.fire({
        icon: "warning",
        title: "Maklumat wajib belum lengkap",
        html: `<div class="text-left">Sila isi/muat naik medan berikut:<ul class="list-disc ml-5 mt-2">${missingFields
          .map((f) => `<li>${f}</li>`)
          .join("")}</ul></div>`,
      });
      return;
    }
    // Only on submit: normalize and store phone numbers to +60 for storage
    updatePektaField("noTel", normalizeToPlus60(trimmedFormData.noTel));
    updateOtherField(
      "noPejabat",
      normalizeToPlus60(trimmedOtherData.noPejabat)
    );
    updateOtherField("noRumah", normalizeToPlus60(trimmedOtherData.noRumah));

    upload();
  }

  const handleMobileChange = (e: ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value.trim();
    updatePektaField("noTel", value);

    if (value === "") {
      setMobileError(null);
      return;
    }
    if (!/^\+?\d+$/.test(value)) {
      setMobileError(
        "Sila gunakan digit sahaja (benarkan '+60' di permulaan). Contoh: 0123456789 atau +60123456789"
      );
      return;
    }
    if (value.startsWith("+") && !value.startsWith("+60")) {
      setMobileError(
        "Jika menggunakan kod negara, sila gunakan +60 di permulaan. Contoh: +60123456789"
      );
      return;
    }
    if (!mobileRegex.test(value)) {
      setMobileError(
        "Format No Tel Bimbit tidak sah. Contoh: 0123456789, 01123456789, atau +60123456789"
      );
    } else {
      setMobileError(null);
    }
  };

  const handleOfficePhoneChange = (e: ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value.trim();
    updateOtherField("noPejabat", value);

    if (value === "") {
      setOfficePhoneError(null);
      return;
    }
    if (!/^\+?\d+$/.test(value)) {
      setOfficePhoneError(
        "Sila gunakan digit sahaja (benarkan '+60' di permulaan). Contoh: 0387654321 atau +60387654321"
      );
      return;
    }
    if (value.startsWith("+") && !value.startsWith("+60")) {
      setOfficePhoneError(
        "Jika menggunakan kod negara, sila gunakan +60 di permulaan. Contoh: +60387654321"
      );
      return;
    }
    if (!landlineRegex.test(value)) {
      setOfficePhoneError(
        "Format No Tel Pejabat tidak sah. Contoh: 0387654321 atau +60387654321"
      );
    } else {
      setOfficePhoneError(null);
    }
  };

  const handleHomePhoneChange = (e: ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value.trim();
    updateOtherField("noRumah", value);

    if (value === "") {
      setHomePhoneError(null);
      return;
    }
    if (!/^\+?\d+$/.test(value)) {
      setHomePhoneError(
        "Sila gunakan digit sahaja (benarkan '+60' di permulaan). Contoh: 058765432 atau +6058765432"
      );
      return;
    }
    if (value.startsWith("+") && !value.startsWith("+60")) {
      setHomePhoneError(
        "Jika menggunakan kod negara, sila gunakan +60 di permulaan. Contoh: +6058765432"
      );
      return;
    }
    if (!landlineRegex.test(value)) {
      setHomePhoneError(
        "Format No Tel Rumah tidak sah. Contoh: 058765432 atau +6058765432"
      );
    } else {
      setHomePhoneError(null);
    }
  };

  // to update negeri dropdown data
  useEffect(() => {
    const initStateData = address_detail.map((states) => states.State);
    setStatedata(initStateData);
  }, []);

  // to update bandar dropdown data
  useEffect(() => {
    const newCitiesData = getTownOptions(pektaData.negeri);
    setCitiesdata(newCitiesData);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pektaData.negeri]);

  // to update poscode dropdown data
  useEffect(() => {
    const newPostcodeData = getPostcodeOptions(
      pektaData.negeri,
      pektaData.bandar
    );
    setPostcodedata(newPostcodeData);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pektaData.negeri, pektaData.bandar]);

  useEffect(() => {
    if (
      login.pektaAppStatus !== "rejected" &&
      login.pektaAppStatus !== "none"
    ) {
      toast.warning(
        `Anda telah membuat permohonan PEKTA yang kini berstatus: ${login.pektaAppStatus} `,
        { position: toast.POSITION.TOP_CENTER }
      );
      navigate("/myprofile");
    } else {
      if (pektaData.kadPengenalan.length === 12) {
        icnumber(pektaData.kadPengenalan);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pektaData.kadPengenalan]);

  return (
    <div>
      <Header />
      <PektaHeader page={"1"} />

      <Container maxWidth={false} disableGutters>
        <div className="sm:flex flex-col justify-center mx-4 sm:mx-24">
          <div className="grid sm:grid-cols-2 xs:grid-cols-1 gap-4 ">
            <div className=" mt-10">
              <p className="text-4xl">Maklumat Individu</p> <br />
              <p className="pb-1">
                {" "}
                <label>
                  Nama Pengguna<label className=" text-red-500">*</label>
                </label>{" "}
              </p>
              <input
                className="  border-2 w-full rounded-md p-1"
                value={pektaData.firstName}
                placeholder="Masukkan nama berdasarkan IC"
                name="firstName"
                id="firstName"
                type={"text"}
                onChange={handleChange}
              />
              <br />
              <br />
              <p className="pb-1">
                {" "}
                <label className=" ">
                  No Kad Pengenalan<label className=" text-red-500">*</label>
                </label>
              </p>
              <input
                maxLength={12}
                className="border-2 w-full rounded-md p-1"
                value={pektaData.kadPengenalan}
                placeholder="Masukkan nombor IC tanpa `-` "
                name="kadPengenalan"
                id="kadPengenalan"
                type={"number"}
                onChange={handleChange}
              />
              <br />
              <br />
              <p className="pb-1">
                {" "}
                <label className=" ">
                  Umur<label className=" text-red-500">*</label>
                </label>
              </p>
              <input
                maxLength={12}
                className="border-2 w-full rounded-md p-1"
                value={pektaData.umur}
                name="umur"
                id="umur"
                type={"text"}
                onChange={handleChange}
              />
              <br />
              <br />
              <p className="pb-1">
                {" "}
                <label className=" ">
                  Jantina<label className=" text-red-500">*</label>
                </label>
              </p>
              <select
                className="border-2 w-full rounded-md p-1"
                value={pektaData.jantina}
                name="jantina"
                id="jantina"
                onChange={handleChange}
              >
                <option></option>
                <option value={"LELAKI"}>LELAKI</option>
                <option value={"PEREMPUAN"}>PEREMPUAN</option>
              </select>
              <br />
              <br />
              <p className="pb-1">
                <label>Email</label>
              </p>
              <input
                disabled={true}
                className="border-2 w-full rounded-md p-1"
                placeholder="Masukkan email anda"
                name="email"
                type={"email"}
                value={login.email.toUpperCase()}
              />
              <br />
              <br />
              <label>
                Gambar Bersaiz Pasport<label className=" text-red-500">*</label>
              </label>
              <br />
              <div>
                <Uploads />
              </div>
              <br />
              <p className="pb-1">
                {" "}
                <label>
                  No Tel Bimbit<label className=" text-red-500">*</label>
                </label>
              </p>
              <input
                className="border-2 w-full rounded-md p-1"
                value={pektaData.noTel}
                onChange={handleMobileChange}
                id="noTel"
                type="tel"
                inputMode="numeric"
              />
              <br />
              {mobileError && <p style={{ color: "red" }}>{mobileError}</p>}
              <br />
              <label>No Tel Pejabat</label>
              <br />
              <input
                className="border-2 w-full rounded-md p-1"
                value={otherPektaData.noPejabat}
                name="noPejabat"
                id="noPejabat"
                type={"tel"}
                inputMode="numeric"
                onChange={handleOfficePhoneChange}
              />
              <br />
              {officePhoneError && (
                <p style={{ color: "red" }}>{officePhoneError}</p>
              )}
              <br />
              <label>No Tel Rumah</label>
              <br />
              <input
                className="border-2 w-full rounded-md p-1"
                value={otherPektaData.noRumah}
                name="noRumah"
                id="noRumah"
                type={"tel"}
                inputMode="numeric"
                onChange={handleHomePhoneChange}
              />
              <br />
              {homePhoneError && (
                <p style={{ color: "red" }}>{homePhoneError}</p>
              )}
              <br />
              <p className="pb-1">
                <label>
                  Status Perkahwinan<label className=" text-red-500">*</label>
                </label>
              </p>
              <select
                className="border-2 w-full rounded-md p-1"
                value={pektaData.tarafKahwin}
                name="tarafKahwin"
                id="tarafKahwin"
                onChange={handleChange}
              >
                <option value=""> </option>
                <option value="BUJANG">BUJANG</option>
                <option value="KAHWIN">KAHWIN</option>
                <option value="DUDA">DUDA</option>
                <option value="JANDA">JANDA</option>
              </select>
              <br />
              <br />
              <p className="pb-1">
                {" "}
                <label>
                  Warganegara Malaysia<label className=" text-red-500">*</label>
                </label>
              </p>
              <select
                className="border-2 w-full rounded-md p-1"
                value={pektaData.warganegara}
                name="warganegara"
                id="warganegara"
                onChange={handleChange}
              >
                <option value=""></option>
                <option value="YA">YA</option>
                <option value="TIDAK">TIDAK</option>
              </select>
              <br />
              <br />
              <p className="pb-1">
                {" "}
                <label>
                  Bangsa<label className=" text-red-500">*</label>
                </label>
              </p>
              <select
                className="border-2 w-full rounded-md p-1"
                value={pektaData.bangsa}
                name="bangsa"
                id="bangsa"
                onChange={handleChange}
              >
                <option value=""> </option>
                <option value="MELAYU"> MELAYU</option>
                <option value="CINA">CINA</option>
                <option value="INDIA">INDIA</option>
                <option value="LAIN-LAIN">LAIN-LAIN </option>
              </select>
              <br />
            </div>

            <div className="  sm:my-10">
              <p className="text-4xl">Alamat</p> <br />
              <p className="pb-1">
                <label>
                  Alamat<label className=" text-red-500">*</label>
                </label>
              </p>
              <input
                className="border-2 w-full rounded-md p-1"
                value={pektaData.alamat}
                name="alamat"
                id="alamat"
                type={"text"}
                onChange={handleChange}
              />
              <br />
              <br />
              <div className="flex ">
                <div className="w-full">
                  <p className="pb-1">
                    {" "}
                    <label>
                      Negeri<label className=" text-red-500">*</label>
                    </label>
                  </p>
                  <select
                    className="border-2 sm:max-w-72 w-full rounded-md p-1"
                    value={pektaData.negeri}
                    name="negeri"
                    id="negeri"
                    onChange={handleChange}
                  >
                    {statedata.map((state: any, index: any) => (
                      <option key={index} value={state}>
                        {state}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="ml-3 w-full">
                  <p className="pb-1">
                    <label>
                      Daerah<label className=" text-red-500">*</label>
                    </label>
                  </p>
                  <select
                    className="border-2 sm:max-w-80 w-full rounded-md p-1"
                    value={pektaData.bandar}
                    name="bandar"
                    id="bandar"
                    onChange={handleChange}
                  >
                    {citiesdata.map((state: any, index: any) => (
                      <option key={index} value={state}>
                        {state}
                      </option>
                    ))}
                  </select>
                </div>
                <br />
                <br />
              </div>
              <div className="flex">
                <div className="w-full pt-6">
                  <p className="pb-1">
                    <label>
                      Poskod<label className=" text-red-500">*</label>
                    </label>
                  </p>

                  <select
                    className="border-2 sm:max-w-72 w-full rounded-md p-1"
                    value={pektaData.poskod}
                    name="poskod"
                    id="poskod"
                    onChange={handleChange}
                  >
                    {postcodedata.map((state: any, index: any) => (
                      <option key={index} value={state}>
                        {state}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              <p className="text-4xl mt-12 pt-2">Maklumat Akaun</p> <br />
              <p className="pb-1">
                {" "}
                <label>
                  No Akaun TH<label className=" text-red-500">*</label>
                </label>{" "}
              </p>
              <input
                className="border-2 w-full rounded-md p-1"
                value={pektaData.akaunTH}
                name="akaunTH"
                id="akaunTH"
                type={"text"}
                onChange={handleChange}
              />
              <br />
              <br />
              <p className="pb-1">
                {" "}
                <label>
                  Nama Bank<label className=" text-red-500">*</label>
                </label>{" "}
              </p>
              <select
                className="border-2 w-full rounded-md p-1"
                value={pektaData.namaBank}
                name="namaBank"
                id="namaBank"
                onChange={handleChange}
              >
                <option value=""></option>
                <option value="AFFIN BANK BERHAD">
                  AFFIN BANK BERHAD/AFFIN ISLAMIC BANK
                </option>
                <option value="AL-RAJHI BANKING">
                  AL-RAJHI BANKING & INVESTMENT CORP (M) Berhad
                </option>
                <option value="ALLIANCE BANK MALAYSIA BERHAD">
                  ALLIANCE BANK MALAYSIA BERHAD
                </option>
                <option value="AMBANK BERHAD">AMBANK BERHAD</option>
                <option value="AGROBANK">
                  BANK PERTANIAN MALAYSIA BERHAD (AGROBANK)
                </option>
                <option value="BANK OF AMERICA">BANK OF AMERICA</option>
                <option value="BANK SIMPANAN NASIONAL BERHAD">
                  BANK SIMPANAN NASIONAL BERHAD
                </option>
                <option value="BANK KERJASAMA RAKYAT">
                  BANK KERJASAMA RAKYAT
                </option>
                <option value="BANGKOK BANK BERHAD">BANGKOK BANK BERHAD</option>
                <option value="BNP PARIBAS MALAYSIA">
                  BNP PARIBAS MALAYSIA
                </option>
                <option value="CHINA CONST BK (M) BHD">
                  CHINA CONST BK (M) BHD
                </option>
                <option value="CIMB BANK BERHAD">CIMB BANK BERHAD</option>
                <option value="CITIBANK BERHAD">CITIBANK BERHAD</option>
                <option value="HONG LEONG BANK">HONG LEONG BANK</option>
                <option value="HSBC BANK MALAYSIA BERHAD">
                  HSBC BANK MALAYSIA BERHAD
                </option>
                <option value="MAYBANK">MAYBANK</option>
                <option value="MBSB BANK">MBSB BANK</option>
                <option value="OCBC BANK (MALAYSIA) BERHAD">
                  OCBC BANK (MALAYSIA) BERHAD
                </option>
                <option value="PUBLIC BANK">PUBLIC BANK</option>
                <option value="RHB BANK">RHB BANK</option>
                <option value="STANDARD CHARTERED BANK">
                  STANDARD CHARTERED BANK
                </option>
                <option value="UNITED OVERSEAS BANK BERHAD">
                  UNITED OVERSEAS BANK BERHAD
                </option>
                <option value="LAIN-LAIN">LAIN-LAIN</option>
              </select>
              <br />
              <br />
              <p className="pb-1">
                {" "}
                <label>
                  No Akaun Bank<label className=" text-red-500">*</label>
                </label>
              </p>
              <input
                className="border-2 w-full rounded-md p-1"
                value={pektaData.akaunBank}
                name="akaunBank"
                id="akaunBank"
                type={"text"}
                onChange={handleChange}
              />
              <br />
              <br />
              <p className="text-4xl">Maklumat Pekerjaan</p> <br />
              <label>
                Sektor Pekerjaan<label className=" text-red-500">*</label>
              </label>
              <br />
              <select
                className="border-2 w-full rounded-md p-1"
                name="sektorPekerjaan"
                id="sektorPekerjaan"
                value={pektaData.sektorPekerjaan}
                onChange={handleChange}
              >
                <option value=""></option>
                <option value="KERAJAAN">KERAJAAN</option>
                <option value="SWASTA">SWASTA</option>
                <option value="SENDIRI">BEKERJA SENDIRI</option>
                <option value="BERSARA">BERSARA</option>
              </select>
              <br />
              <br />
              <label>
                Pekerjaan
                {pektaData.sektorPekerjaan !== "BERSARA" && (
                  <label className=" text-red-500">*</label>
                )}
              </label>
              <br />
              <input
                className="border-2 w-full rounded-md p-1"
                value={pektaData.pekerjaan}
                name="pekerjaan"
                id="pekerjaan"
                type={"text"}
                onChange={handleChange}
              />
              <br />
              <br />
              <label>
                Nama Majikan
                {pektaData.sektorPekerjaan !== "SENDIRI" &&
                  pektaData.sektorPekerjaan !== "BERSARA" && (
                    <label className=" text-red-500">*</label>
                  )}
              </label>
              <br />
              <input
                className="border-2 w-full rounded-md p-1"
                value={otherPektaData.namaMajikan}
                name="namaMajikan"
                id="namaMajikan"
                type={"text"}
                onChange={handleOtherChange}
                // disabled={
                //   pektaData.pekerjaan === "SENDIRI" ||
                //   pektaData.pekerjaan === "BERSARA"
                // }
              />
              <br />
              <br />
              <label>
                Alamat Majikan
                {pektaData.sektorPekerjaan !== "SENDIRI" &&
                  pektaData.sektorPekerjaan !== "BERSARA" && (
                    <label className=" text-red-500">*</label>
                  )}
              </label>
              <br />
              <textarea
                className="resize border-2 w-full h-20 rounded-md p-1"
                value={otherPektaData.alamatMajikan}
                name="alamatMajikan"
                id="alamatMajikan"
                onChange={handleOtherChange}
                // disabled={
                //   pektaData.pekerjaan === "SENDIRI" ||
                //   pektaData.pekerjaan === "BERSARA"
                // }
              ></textarea>
              <br />
              <br />
            </div>
          </div>
        </div>
      </Container>
      <div className="text-center my-16">
        <button
          className="border-2 bg-green-600 text-white rounded-lg p-2"
          onClick={(e) => {
            validateForm(e);
          }}
        >
          Seterusnya ❯
        </button>
      </div>

      <Modal
        open={open}
        onClose={() => console.log("close")}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <div className="flex justify-center md:mt-40 lg:mt-48 xl:mt-56">
          <CircularProgress color="success" size={200} />
        </div>
      </Modal>
    </div>
  );
}
